import React from 'react';
import {connect} from 'react-redux';
import {Card, Form, Select, Header, Grid, Button} from 'semantic-ui-react';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {hasAccessPermission} from '../../../common/permissions/validations';
import Calendar from './Calendar';
import './budget.scss';
import DatePickerWrapper from './DatePickerWrapper';
import {Actions} from '../../../common/actions';
import TableSemanctic from './TableSemantic';
import moment from 'moment';
import {validateDate} from '../../utils';

const monthOptions = [
  {'key': '', 'value': '', 'text': ''},
  {'key': '1', 'value': 1, 'text': 'Enero'},
  {'key': '2', 'value': 2, 'text': 'Febrero'},
  {'key': '3', 'value': 3, 'text': 'Marzo'},
  {'key': '4', 'value': 4, 'text': 'Abril'},
  {'key': '5', 'value': 5, 'text': 'Mayo'},
  {'key': '6', 'value': 6, 'text': 'Junio'},
  {'key': '7', 'value': 7, 'text': 'Julio'},
  {'key': '8', 'value': 8, 'text': 'Agosto'},
  {'key': '9', 'value': 9, 'text': 'Septiembre'},
  {'key': '10', 'value': 10, 'text': 'Octubre'},
  {'key': '11', 'value': 11, 'text': 'Noviembre'},
  {'key': '12', 'value': 12, 'text': 'Diciembre'},
];
const yearsOptions = [
  {'key': '1', 'value': 2019, 'text': '2019'},
  {'key': '2', 'value': 2020, 'text': '2020'},
  {'key': '3', 'value': 2021, 'text': '2021'},
  {'key': '4', 'value': 2022, 'text': '2022'},
  {'key': '5', 'value': 2023, 'text': '2023'},
  {'key': '6', 'value': 2024, 'text': '2024'},
  {'key': '7', 'value': 2025, 'text': '2025'},
  {'key': '8', 'value': 2026, 'text': '2026'},
  {'key': '9', 'value': 2027, 'text': '2027'},
  {'key': '10', 'value': 2028, 'text': '2028'},
  {'key': '11', 'value': 2029, 'text': '2029'},
  {'key': '12', 'value': 2030, 'text': '2030'},
];

const ERROR_MESSAGE = 'La fecha se encuentra asignada';
const dateFormat = 'YYYY-MM-DD';
const year = moment().year();
const month = moment().month() + 1;

class ManageDatesBudget extends React.Component {
  state = {
    'month': moment().month() + 1,
    'year': moment().year(),
    'startDate': null,
    'endDate': null,
  };

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.ManageDatesBudget, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }

    this.props.fetchBudgetsDates(year, month);
  }

  handleDatesChange = ({startDate, endDate}) => {
    const {dates} = this.props;
    const validateDates = startDate && endDate;
    this.setState({startDate, endDate});

    if (validateDates) {
      const dateFormattedStart = moment(startDate).format(dateFormat);
      const dateFormatteddEnd = moment(endDate).format(dateFormat);
      const year = moment(startDate).year();
      const month = moment(startDate).month() + 1;
      const data = {
        'startDate': dateFormattedStart,
        'endDate': dateFormatteddEnd,
        year,
        month,
      };
      const result = validateDate(dates, dateFormattedStart, dateFormatteddEnd);

      if (result) {
        this.props.addMessageBoxError(ERROR_MESSAGE);
        this.setState({
          'startDate': null,
          'endDate': null,
        });
      } else {
        this.props.addItemBudgetDates(data, year, month);
        this.setState({
          'startDate': null,
          'endDate': null,
        });
      }
    }
  };

  handleOnChangeSelectMonth = (e, {value}) => {
    const {year} = this.state;
    this.setState({'month': value});
    this.props.fetchBudgetsDates(year, value);
    this.setState({
      'startDate': null,
      'endDate': null,
    });
  };
  handleOnChangeSelectYear = (e, {value}) => {
    const {month} = this.state;
    this.setState({'year': value});
    this.props.fetchBudgetsDates(value, month);
    this.setState({
      'startDate': null,
      'endDate': null,
    });
  };

  handleSubmit = (event) => {
    const {year, month} = this.state;
    this.props.fetchBudgetsDates(year, month);
    this.setState({
      'startDate': null,
      'endDate': null,
    });
    event.preventDefault();
  };

  render() {
    const {year, month, startDate, endDate} = this.state;

    return (
      <div className="forms-template-list">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Gestión de fechas</h2>
            </div>
            <div className="ui grid container__budget_header">
              <Form onSubmit={this.handleSubmit} className="container__budget_form">
                <Form.Group widths="equal">
                  <Form.Field
                    value={year}
                    onChange={this.handleOnChangeSelectYear}
                    name="year"
                    control={Select}
                    label="Seleccionar año"
                    options={yearsOptions}
                    placeholder="Seleccionar año"
                  />

                  <Form.Field
                    value={month}
                    onChange={this.handleOnChangeSelectMonth}
                    name="month"
                    control={Select}
                    label="Seleccionar mes"
                    options={monthOptions}
                    placeholder="Seleccionar mes"
                  />
                </Form.Group>
                <Form.Field type="submit" control={Button}>
                  Buscar
                </Form.Field>
              </Form>

              <Form className="container__budget_form container__budget_form-calendar ">
                <Form.Group>
                  <div className=" calendar__aribnb">
                    <p>Seleccionar fechas</p>
                    <Calendar
                      year={year}
                      month={month}
                      startDate={startDate}
                      endDate={endDate}
                      handleDatesChange={this.handleDatesChange}
                    />
                  </div>
                </Form.Group>
              </Form>
            </div>
          </div>
        </Card>

        <Card raised fluid>
          <div className="container__result-calendar">
            <Header as="h1">Resultados</Header>
            <Grid columns={2} divided>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <TableSemanctic dates={this.props.dates} />
                </Grid.Column>
                <Grid.Column>
                  <div className="daypicker__container">
                    <DatePickerWrapper dates={this.props.dates} />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {manageDates, loading} = state.budgets;
  return {
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'dates': manageDates,
    'loading': loading,
  };
};

const {fetchBudgetsDates, addItemBudgetDates, addMessageBoxError, withRouter} = Actions;

export default withRouter(connect(
  mapStateToProps,
  {
    fetchBudgetsDates,
    addItemBudgetDates,
    addMessageBoxError,
  }
)(ManageDatesBudget));
